module.exports = __webpack_public_path__ + "img/bank-connection-failure.5904ffdb.png";